import './style/index.css';
import './style/tabs.css';
import App from './components/app';

export default App;